export enum RoleName {
  User = "User",
  AdminUser = "AdminUser",
  TeacherUser = "TeacherUser",
}
